import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PricingOffer() {
  const includes = ['Guía profunda paso a paso', 'Presupuesto de 1 página', 'Plan de 60 días', 'Checklist de recortes y negociación de gastos'];
  return <section id="comprar" className="py-24 relative overflow-hidden" data-id="element-183">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-184" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-185">
        <FadeIn data-id="element-186">
          <div className="max-w-lg mx-auto bg-gradient-to-b from-navy-800 to-navy-900 rounded-3xl border border-gold-500/30 p-8 md:p-12 shadow-[0_0_50px_rgba(201,168,76,0.15)] relative overflow-hidden" data-id="element-187">
            {/* Shine effect */}
            <div className="absolute top-0 left-[-100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/5 to-transparent skew-x-[-20deg] animate-[shine_8s_infinite]" data-id="element-188" />

            <div className="text-center mb-8" data-id="element-189">
              <h2 className="text-3xl font-bold text-white mb-2" data-id="element-190">
                Finanzas Sin Excusas
              </h2>
              <p className="text-slate-400" data-id="element-191">(eBook completo)</p>
            </div>

            <div className="mb-8" data-id="element-192">
              <p className="text-sm font-bold text-gold-500 uppercase tracking-wider mb-4" data-id="element-193">
                Incluye:
              </p>
              <ul className="space-y-3" data-id="element-194">
                {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-195">
                    <CheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0 mt-0.5" data-id="element-196" />
                    <span className="text-slate-200" data-id="element-197">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center mb-10 pb-8 border-b border-white/10" data-id="element-198">
              <p className="text-slate-400 mb-2 uppercase tracking-widest text-sm" data-id="element-199">
                Precio
              </p>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-200">
                <span className="text-2xl text-slate-500 line-through" data-id="element-201">
                  $19.99
                </span>
              </div>
              <div className="flex items-center justify-center gap-1" data-id="element-202">
                <span className="text-3xl font-bold text-gold-500" data-id="element-203">$</span>
                <span className="text-6xl font-bold text-white" data-id="element-204">6.39</span>
              </div>
              <div className="mt-3 inline-block bg-green-500/15 border border-green-500/30 rounded-full px-4 py-1" data-id="element-205">
                <span className="text-green-400 text-sm font-bold" data-id="element-206">
                  Ahorra 68%
                </span>
              </div>
            </div>

            <a href="https://reckiva.com/cart/48040237727844:1" target="_blank" rel="noopener noreferrer" className="btn-gold w-full group text-xl py-5" data-id="element-207">
              Sí, quiero ordenar mis finanzas
              <ArrowRightIcon className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-208" />
            </a>
          </div>
        </FadeIn>
      </div>

      <style data-id="element-209">{`
        @keyframes shine {
          0% { left: -100%; }
          20% { left: 200%; }
          100% { left: 200%; }
        }
      `}</style>
    </section>;
}